export default __webpack_public_path__ + "static/Calibre-LightItalic-e2841659f2a585a23bff940e8f6056d3.ttf";